import isNumber from 'lodash/isNumber';
import { localizeInteger } from 'utils/i18nHelpers';

export const getListText = (listLength: number) => `Contact${listLength === 1 ? '' : 's'}`;

export const getListSizeDisplayText = (size: unknown) => {
  if (isNumber(size)) return localizeInteger(size as number);
  return 'Not available';
};
